import { cn } from "@/lib/utils";

/** Simple line-art double-helix motif used as a calm decorative element. */
export function Helix({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 120 320"
      fill="none"
      aria-hidden="true"
      className={cn("text-primary/40", className)}
    >
      <path
        d="M30 0C30 40 90 40 90 80S30 120 30 160s60 40 60 80-60 40-60 80"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M90 0C90 40 30 40 30 80s60 40 60 80-60 40-60 80 60 40 60 80"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      {[20, 50, 100, 130, 180, 210, 260, 290].map((y, i) => (
        <line
          key={y}
          x1={i % 2 === 0 ? 38 : 34}
          x2={i % 2 === 0 ? 82 : 86}
          y1={y}
          y2={y}
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          opacity={0.6}
        />
      ))}
    </svg>
  );
}

/** Small inline helix mark for the logo. */
export function HelixMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" fill="none" aria-hidden="true" className={cn("size-7", className)}>
      <path
        d="M9 3c0 6 14 6 14 13S9 22 9 29"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M23 3c0 6-14 6-14 13s14 6 14 13"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line x1="11" y1="8" x2="21" y2="8" stroke="currentColor" strokeWidth="1.5" opacity="0.7" />
      <line x1="11" y1="24" x2="21" y2="24" stroke="currentColor" strokeWidth="1.5" opacity="0.7" />
    </svg>
  );
}
